<template>
  <div class="members">
    <el-tabs type="card" value="members">
      <el-tab-pane :label="'Участники ' + totalMemberCount" name="members">
        <el-card>
          <evaluation-users-table
            :isDisabledSetting="evaluation && evaluation.status === 'finished'"
            ref="membersTable"
            @update-total-count="totalMemberCount = $event"
            @refresh-all="refreshAllTables"
          ></evaluation-users-table>
        </el-card>
      </el-tab-pane>
      <el-tab-pane
        v-if="evaluation.status && evaluation.status !== 'finished'"
        name="errors"
      >
        <template #label>
          Ошибки
          <span :style="{ color: totalProfileErrorCount > 0 ? 'red' : 'inherit' }">
            {{ totalProfileErrorCount }}
          </span>
        </template>
        <el-card>
          <evaluation-users-table
            :isDisabledSetting="evaluation.status && evaluation.status === 'finished'"
            ref="errorsTable"
            :isProfileError="true"
            :totalProfileErrorCount="totalProfileErrorCount"
            @update-total-count="totalProfileErrorCount = $event"
            @refresh-all="refreshAllTables"
          ></evaluation-users-table>
        </el-card>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import EvaluationUsersTable from "@/modules/evaluation/components/evaluation/EvaluationUsersTable.vue";

export default {
  name: "evaluation-members",
  components: {EvaluationUsersTable},
  props: {
    evaluation: {
      type: Object,
      default: {},
    },
  },
  watch: {
    totalProfileErrorCount(val) {
      this.$emit('update-total-count', val);
    }
  },
  data() {
    return {
      totalMemberCount: 0,
      totalProfileErrorCount: 0,
    };
  },
  methods: {
    refreshAllTables() {
      this.$refs.membersTable?.loadEvaluationUsers();
      this.$refs.errorsTable?.loadEvaluationUsers();
      this.$emit('refresh-evaluators');
    }
  },
}
</script>

<style scoped>

</style>